<script lang="ts">
  import PageSection from '@athena-lib/Page/PageSection.svelte';
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import clsx from 'clsx';
  import type { Market } from '$lib/i18n';
  import type { AccountData } from '$lib/server/external/customerExternalData';
  const translations = getCommonTranslations();

  const {
    currentPage,
    market,
    accountData,
  }: {
    accountData: AccountData;
    currentPage: 'customer' | 'orders' | 'taxCertificates';
    market: Market;
  } = $props();
</script>

<PageSection backgroundColor="light" ySpace="small">
  <div class="flex flex-row gap-8 text-sm text-st-gray-600">
    <a href="/customer" class={clsx(currentPage == 'customer' && 'text-st-gray-800')}>
      {translations.account}
    </a>
    <a href="/customer/orders" class={clsx(currentPage == 'orders' && 'text-st-gray-800')}>
      {translations.orders}
    </a>
    {#if (accountData.billing.is_company && accountData.billing.country_code === 'us') || market.countryCode === 'us'}
      <a
        href="/customer/taxCertificates"
        class={clsx(currentPage == 'taxCertificates' && 'text-st-gray-800')}
      >
        {translations.taxCertificates}
      </a>
    {/if}
    <a href="/customer/logout">
      {translations.logout}
    </a>
  </div></PageSection
>
